import { isArray, compact } from "lodash";
import moment from "moment";
import dateParser from "lib/date-parser";

// compare type must be last_year or previous
export default function toPreviousDateRange(
  dateRangeOrString = [],
  compareType
) {
  // the date could be a string such as "Today", "This year" or an array
  const dateRange = isArray(dateRangeOrString)
    ? dateRangeOrString
    : dateParser(dateRangeOrString);

  if (!isArray(dateRange) || dateRange.length !== 2) {
    return null;
  }

  //let dates = dateParser(dateRange);

  let mStart = moment(dateRange[0], "YYYY-MM-DDTHH:mm:ss.SSS");
  let mEnd = moment(dateRange[1], "YYYY-MM-DDTHH:mm:ss.SSS");

  if (false === mStart.isValid() || false === mEnd.isValid()) {
    return null;
  }

  let dif = mEnd.diff(mStart, "days");
  dif = dif === 0 ? 1 : dif;

  if (false === mStart.isValid() || false === mEnd.isValid()) {
    return null;
  }

  // probaly need some logic to check if its a leap year
  return compact([
    mStart
      .subtract(compareType === "last_year" ? 366 : dif, "days")
      .format("YYYY-MM-DD"),
    mEnd
      .subtract(compareType === "last_year" ? 366 : dif, "days")
      .format("YYYY-MM-DD"),
  ]);
}
